var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { StyledRichText } from "./RichText.style";
export const RichText = React.forwardRef((_a, ref) => {
    var { inverse } = _a, props = __rest(_a, ["inverse"]);
    return _jsx(StyledRichText, Object.assign({ ref: ref, "$inverse": inverse }, props));
});
RichText.displayName = "RichText";
export default RichText;
//# sourceMappingURL=RichText.js.map